export default [
  {
    _name: 'CSidebarNav',
    _children: [
      {
        _name: 'CSidebarNavItem',
        name: 'Dashboard',
        to: '/dashboard',
        icon: 'cil-speedometer',
        // badge: {
        //   color: 'primary',
        //   text: 'NEW'
        // }
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['App Editor']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Screens',
        to: '/screens',
        icon: 'cil-grid',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Blocks',
        to: '/blocks',
        icon: 'cil-square',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Links',
        to: '/links',
        icon: 'cil-link',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Tabs',
        to: '/tabs',
        icon: 'cil-hand-point-up',
      },
      {
        _name: 'CSidebarNavTitle',
        _children: ['App Contents']
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Our podcasts',
        to: '/podcasts/ourpodcasts',
        icon: 'cil-rss',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'All podcasts',
        to: '/podcasts/podcasts',
        icon: 'cil-magnifying-glass',
      },
      {
        _name: 'CSidebarNavItem',
        name: 'Episodes',
        to: '/podcasts/episodes',
        icon: 'cil-microphone'
      },
      {
        _name: 'CSidebarNavDropdown',
        name: 'Crawler',
        route: '/crawler',
        icon: 'cil-bug',
        items: [
          {
            name: 'To Do',
            to: '/crawler/todo',
            icon: 'cil-globe-alt',
          },
          {
            name: 'Errors',
            to: '/crawler/errors',
            icon: 'cil-warning'
          },
        ]
      },
    ]
  }
]